var _ellipse, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 26.5,
    rx: 13,
    ry: 4.5,
    fill: "url(#paint0_radial_17773_2365)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C11.0243 2 7 6.019 7 10.9882C7 16.3426 12.6829 23.7257 15.0229 26.5377C15.5371 27.1541 16.4757 27.1541 16.99 26.5377C19.3171 23.7257 25 16.3426 25 10.9882C25 6.019 20.9757 2 16 2ZM16 14.1983C14.2257 14.1983 12.7857 12.7601 12.7857 10.9882C12.7857 9.21623 14.2257 7.77812 16 7.77812C17.7743 7.77812 19.2143 9.21623 19.2143 10.9882C19.2143 12.7601 17.7743 14.1983 16 14.1983Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_17773_2365",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 26.5) rotate(90) scale(4.5 13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.254808,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location_on.a109f9cd36ae689176bb59c20b5f284e.svg";
export { ForwardRef as ReactComponent };